import axios from "axios";
import i18n from "@/services/i18next";
import { getSettings } from "@/services/settings";

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const currentLanguage = i18n.language;

    config.headers["Accept-Language"] = currentLanguage;

    const settings = await getSettings();
    config.baseURL = settings.BASE_URL;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
